export default __webpack_public_path__ + "static/media/generate-report-1.e561a0d7.svg";